/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Filters from '../../../../components/Filters'
import Button from '../../../../components/Button'
import { ControlTable } from '../../../../components/Table';
import useForm from '../../../../hooks/useForm';
import { getParams } from '../../../../utils/params';
import { isEmpty } from 'lodash';
import systemAlert from '../../../../utils/systemAlert';
import { dateToViewFormat, getDay } from '../../../../utils/date';
import { createCardRecordsUseItems, } from '../../../../apis/finances/cards';
import { EXPENSE_SEARCH_LIST, PAYMENT_TYPE } from '../../../../constants/EXPENSE';
import { onLoadMultiImage } from '../../../../utils/image';
import { getExpenseList/*, getExpenseOptionsList*/ } from '../../../../apis/expense';

import { TASK_STATUS_LIST } from "../../../../constants/TASK";
import DataComponent from "../../../../components/DataComponent";
import { cloneDeep, isArray } from "lodash-es";


const ExpenseListModal = ({ open, setOpen, cardData, detailSubmit, type }) => {
  const [filters, setFilters] = useState([]);
  const [fields] = useState([
    {
      title: "작성일시",
      key: "createdTime",
      onValue: (value) => {
        return (
          <div className="list-date-wrap">
            <p className="list-date">{dateToViewFormat(value)}</p>
            <p className="list-date-time">{dateToViewFormat(value, "HH:mm")}</p>
          </div>
        );
      },
    },
    {
      title: "사용일",
      key: "expenseItems[0].useTime",
      onValue: (value) => {
        return (
          <div className="list-date-wrap">
            <p className="list-date">{dateToViewFormat(value)}</p>
          </div>
        );
      },
    },
    {
      title: "영수증이미지",
      key: "billImgUrl",
      onValue: (value, field, data) => {
        const billFiles = data.expenseItems[0].billFiles;

        return billFiles.map((bill, idx) => (
          <div
            key={idx}
            className="bill-img-wrap"
            onClick={() => handleOnClick(billFiles, idx)}
          >
            <img src={bill.fileUrl} alt={bill.originalName} />
          </div>
        ));
      },
    },
    {
      title: "작성자",
      key: "reqEmployeeIdx",
      type: "profile",
      className: "expense-list-user-profile",
    },
    {
      title: "타입",
      key: "payType",
      onTranslator: {
        list: PAYMENT_TYPE,
      },
    },
    { title: "합계금액", key: "useAmt", type: "comma" },
    { title: "비용항목", key: "expenseOptionName" },
    {
      title: "결재상태",
      key: "apprStatus",
      onValue: (value) => {
        const target = TASK_STATUS_LIST.find(
          (vacation) => vacation.status === value
        );
        return (
          <DataComponent
            field={{
              type: "badge",
              color: target.color,
              label: target.label,
            }}
          />
        );
      },
    },
  ]);

  const cancel = () => {
    setOpen(false)
    reset()
  }

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    setInForm,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reset
  } = useForm(
    {
      order: [
        {
          createdTime: "desc"
        },
      ],
      range: {
        createdTime: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10,
      requestEmployees: []
    },
  )

  useEffect(() => {
    setFilters([
      {
        title: '조회기간',
        type: 'customdatepicker',
        key: 'range.createdTime',
      },
      {
        title: "선택한 항목만 보기",
        key: "check",
        type: "checkboxes",
        className: "margin-right-16",
        onChange: (checked, key) => {
          setInForm(key, checked)
        },
        options: {
          list: EXPENSE_SEARCH_LIST,
        },
      },
      /*
      {
        title: "결재상태",
        type: "select",
        key: "apprGranted",
        defaultValue: '',
        options: {
          list: [
            { label: "전체", value: '' },
            ...APPR_STATUS
          ]
        },
      },
      {
        title: "비용항목",
        type: "select",
        key: "expenseOptionIdx",
        defaultValue: '',
        options: {
          list: async () => {
            const list = await getExpenseOptionsList()
            return [
              { label: "전체", value: '' },
              ...list.map(d => ({
                label: d.name,
                value: d.idx
              }))
            ]
          }
        }
      },
      */
      {
        title: '작성자',
        type: 'searchEmployees',
        key: 'requestEmployees',
      },
    ])
  }, [form])

  useEffect(() => {
    if (open)
    {
      submit(form);
      setSubmit(submit)
    }
  }, [open]);


  const setParams = (params) => {

    const _params = cloneDeep(params)
    //console.log(_params)
    if (isArray(_params.requestEmployees))
    {
      _params.requestEmployees = _params.requestEmployees.map(e => e.idx)
    }
    if (isEmpty(_params.requestEmployees))
    {
      _params.requestEmployees = undefined
    }
    //console.log(getParams(_params))
    return { _params }
  }

  const submit = (params) => {

    const { _params } = setParams(params)

    getExpenseList({ ...getParams(_params) }).then((res) => {
      setTotal(res.data.totalCount)
      setList(res.data.expenses)
    }).catch(() => { })
      .finally(() => setIsLoading(false))
  };

  const handleApply = () => {
    const body = {
      list: selectedList.map((d) => ({
        cardUseType: type,
        cardUseIdx: cardData.idx,
        itemType: "expense",
        itemIdx: d.idx
      }))
    }

    systemAlert('선택된 경비 청구 내역을 연관데이터로 등록하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            createCardRecordsUseItems(body).then(() => { detailSubmit(); cancel(); })
          }
        }
      ]
    })
  }

  const handleOnClick = (files, selected) => {

    onLoadMultiImage(files, selected);
  };


  return (
    <div className="expense-list">
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        fields={fields}
        list={list}
        selectedList={selectedList}
        setSelected={setSelectedList}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        submit={handleSubmit}
      />
      <div className="submit-button-wrap float-right margin-top-32">
        <Button
          className="button"
          size="lg"
          label="취소"
          color="text"
          action={cancel}
        />
        <Button
          className="button"
          size="lg"
          label="적용하기"
          action={handleApply}
          disabled={isEmpty(selectedList)}
        />
      </div>
    </div>
  )
}

export default ExpenseListModal;